import { useState } from 'react';
import { LocationFormProps, EditableFieldProps } from '../../types/calendar';

function EditableField({ value, placeholder, field, onFieldChange, fontStyle, className = 'w-full' }: EditableFieldProps) {
  const [isEditing, setIsEditing] = useState(!value);

  if (isEditing) {
    return (
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onFieldChange(field, e.target.value)}
        onBlur={() => {
          if (value) setIsEditing(false);
        }}
        autoFocus
        className={`${className} px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
        style={fontStyle}
      />
    );
  }

  return (
    <div
      onClick={() => setIsEditing(true)}
      className={`${className} px-3 py-2 text-sm border border-transparent rounded-md cursor-pointer hover:bg-white/30 transition-colors`}
      style={fontStyle}
      title="Click to edit"
    >
      {value}
    </div>
  );
}

export function LocationForm({ location, onFieldChange }: LocationFormProps) {
  const fontStyle = {
    fontFamily: location.fontFamily || 'Inter, sans-serif',
    color: location.textColor || '#000000'
  };

  return (
    <div className="space-y-2">
      <EditableField
        value={location.agency_combine}
        placeholder="Business Name"
        field="agency_combine"
        onFieldChange={onFieldChange}
        fontStyle={fontStyle}
      />
      <EditableField
        value={location.additional_agents}
        placeholder="Business Alias"
        field="additional_agents"
        onFieldChange={onFieldChange}
        fontStyle={fontStyle}
      />
      <EditableField
        value={location.street}
        placeholder="Street Address"
        field="street"
        onFieldChange={onFieldChange}
        fontStyle={fontStyle}
      />
      <EditableField
        value={location.city}
        placeholder="City"
        field="city"
        onFieldChange={onFieldChange}
        fontStyle={fontStyle}
      />
      <div className="grid grid-cols-2 gap-2">
        <EditableField
          value={location.state}
          placeholder="State"
          field="state"
          onFieldChange={onFieldChange}
          fontStyle={fontStyle}
        />
        <EditableField
          value={location.zip}
          placeholder="ZIP"
          field="zip"
          onFieldChange={onFieldChange}
          fontStyle={fontStyle}
        />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <EditableField
          value={location.phone}
          placeholder="Phone"
          field="phone"
          onFieldChange={onFieldChange}
          fontStyle={fontStyle}
        />
        <EditableField
          value={location.cell_phone}
          placeholder="Cell Phone"
          field="cell_phone"
          onFieldChange={onFieldChange}
          fontStyle={fontStyle}
        />
      </div>
      <EditableField
        value={location.other_info}
        placeholder="Email Address"
        field="other_info"
        onFieldChange={onFieldChange}
        fontStyle={fontStyle}
      />
    </div>
  );
}
